module.exports = __webpack_public_path__ + "img/montserrat-v15-latin-600italic.e20521d1.svg";